import { CALL_API } from '../../api/';
import { Schemas } from '../../api/schema';
import * as ActionTypes from './actionTypes';

const fetchPros = (nextPageUrl) => ({
  [CALL_API]: {
    types: [
      ActionTypes.FETCH_PROS_REQUEST,
      ActionTypes.FETCH_PROS_SUCCESS,
      ActionTypes.FETCH_PROS_FAILURE
      ],
    endpoint: nextPageUrl,
    schema: Schemas.PRO_ARRAY,
    sortByParams: ['id'],
  }
})

export const loadPros = (nextPage) => (dispatch, getState) => {
  const {
    //nextPageUrl = `organizers?_page=1&_limit=6`,
    nextPageUrl = `organizers`,
    pageCount = 0
  } = getState().pagination.prosPaginated || {}

  if (pageCount > 0 && !nextPage) {
    return Promise.resolve();
  }
  if(pageCount > 0 && nextPage) {
    return dispatch({
      type: ActionTypes.NEXT_PROS_PAGE
    });
  }
  return dispatch(fetchPros(nextPageUrl));
}

const fetchPro = (id) => ({
  [CALL_API]: {
    types: [
      ActionTypes.FETCH_PRO_REQUEST,
      ActionTypes.FETCH_PRO_SUCCESS,
      ActionTypes.FETCH_PRO_FAILURE
      ],
    endpoint: `organizers/${id}`,
    schema: Schemas.PRO
  }
})

export const loadPro = (id, requiredFields = []) => (dispatch, getState) => {
  const pro = getState().entities.pros[id];
  if (pro && requiredFields.every(key => pro.hasOwnProperty(key))) {
    return Promise.resolve();
  }
  return dispatch(fetchPro(id));
}



// WEBPACK FOOTER //
// ./src/modules/pros/actions.js